import { render } from "./Menu.vue?vue&type=template&id=00839582&scoped=true&ts=true"
import script from "./Menu.vue?vue&type=script&lang=ts"
export * from "./Menu.vue?vue&type=script&lang=ts"

import "./Menu.vue?vue&type=style&index=0&id=00839582&lang=scss&scoped=true"

import exportComponent from "C:\\BuildAgent\\work\\e394cd1ec4c7054f\\src\\TicketSolutions.Personalisation.Client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00839582"]])

export default __exports__